define([
	"csi/api",
    "csi/canvas/storeFactory",
    "csi/xml",
    "csi/reflectionHints"
], function(api,storeFactory,xml,reflectionHints) {
    reflectionHints.setTarget("VIPClusterAssortment", "Products", "VIPClusterAssortmentProduct");
    reflectionHints.setTarget("VIPClientAssortment", "Products", "VIPClientAssortmentProduct");
    reflectionHints.setTarget("VIPDoorAssortment", "Products", "VIPDoorAssortmentProduct");
	api.allowReferenceDocumentsOnType("Colorway", true);
    return {};
});